import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type I20GenesysWebMessagingProps = RenderingProps<
  I20GenesysWebMessagingFields,
  I20GenesysWebMessagingParams
>;

export type I20GenesysWebMessagingFields = {
  DeploymentID?: Field<string>;
  BusinessUnit?: Field<string>;
};

export type I20GenesysWebMessagingParams = DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
